import styled from 'styled-components';
import Styled from 'styled-components';

const MultiPlatformIconStyled = styled.div``;

export { MultiPlatformIconStyled };
